/** See `src/i18n/locales/en/reports.ts`. */
export const reports = {
  page: {
    title: 'Rapporti',
    lead: 'Rapporti per {{company}}, costruiti a partire dai dati esistenti — non viene memorizzato alcun dato di rapporto separato.',
    noScope: 'Seleziona un’azienda per vedere i suoi rapporti.',
    forbidden: 'Non sei autorizzato a vedere i rapporti di questa azienda.',
  },
  library: {
    title: 'Libreria dei rapporti',
  },
  cards: {
    vitaliteitstrends: {
      title: 'Tendenze mensili di vitalità',
      description: 'Numero totale di passi al mese in tutta l’azienda.',
    },
    deelnamerapport: {
      title: 'Rapporto di partecipazione',
      description: 'Quanti membri sono attivi, e da quanto tempo.',
    },
    'challenge-resultaten': {
      title: 'Risultati delle challenge',
      description: 'Challenge per stato e progresso medio dei partecipanti.',
    },
    communicatiebereik: {
      title: 'Copertura della comunicazione',
      description: 'Notifiche inviate, consegnate e aperte.',
    },
    documentgebruik: {
      title: 'Utilizzo dei documenti',
      description: 'Documenti pubblicati/archiviati e il loro numero totale di visualizzazioni.',
    },
  },
  actions: {
    exportCsv: 'Esporta CSV',
    exportPdf: 'Esporta PDF',
  },
  export: {
    pdfFallbackNote:
      'L’esportazione in PDF non è ancora disponibile — è stato scaricato invece un file CSV.',
    error: 'Non è stato possibile esportare questo rapporto.',
  },
} as const;
